import React from "react";
import { LegacyCard as Card, InlineStack, Select, Text, Pagination } from "@shopify/polaris";
import PropTypes from "prop-types";

const ActivityListFooter = (props) => {
  const { optionsList, onSelectLimit, perPageCount, totalCount, onPerPage, currentPage, cms } = props;
  let maxPage = (totalCount && totalCount && parseInt(totalCount / perPageCount, 10)) || 0;
  maxPage = (maxPage && ((totalCount % perPageCount && maxPage + 1) || maxPage)) || 0;
  return (
    <>
      <Card.Section>
        <InlineStack align={"space-between"} blockAlign="center">
          <Text variant="headingMd" as="h2">
            {`${cms("common.label.totalCount")}:`}
            <span className="totalCount">{totalCount}</span>
          </Text>
          {(maxPage && (
            <Pagination
              hasPrevious={(maxPage && parseInt(currentPage, 10) !== 1 && true) || false}
              onPrevious={() => {
                if (parseInt(currentPage, 10) !== 1) {
                  onPerPage(parseInt(currentPage, 10) - 1);
                }
              }}
              hasNext={(parseInt(currentPage, 10) < maxPage && true) || false}
              onNext={() => {
                if (parseInt(currentPage, 10) <= totalCount) {
                  onPerPage(parseInt(currentPage, 10) + 1);
                }
              }}
            />
          )) ||
            ""}
          <Select value={perPageCount} options={optionsList} onChange={onSelectLimit} />
        </InlineStack>
      </Card.Section>
    </>
  );
};

ActivityListFooter.defaultProps = {
  optionsList: [],
  perPageCount: "",
  totalCount: "",
  currentPage: 1,
  onSelectLimit: () => {},
  onPerPage: () => {},
  cms: () => {},
};

ActivityListFooter.propTypes = {
  optionsList: PropTypes.arrayOf(PropTypes.object),
  perPageCount: PropTypes.number,
  totalCount: PropTypes.number,
  onSelectLimit: PropTypes.func,
  onPerPage: PropTypes.func,
  currentPage: PropTypes.number,
  cms: PropTypes.func,
};

export default ActivityListFooter;
